var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('HomeContentEn',{staticClass:"home_content"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }